module.exports = __webpack_public_path__ + "static/media/IMG_1464.e07b61ea.JPG";